<!--行情-->
<template>
    <div class="id">
        <div class="navBar" @click="$router.back()">
            <van-icon name="arrow-left" />
            {{ $t('DeFi借币') }}
        </div>
        <!-- <div class="topBox">
            <div class="boxIt">
                <div> {{ $t('已借金额') }}(USDT)</div>
                <div>0.00</div>
            </div>
            <div class="boxIt">
                <div> {{ $t('剩余还币数量') }}(USDT)</div>
                <div>0.00</div>
            </div>
        </div> -->

        <div class="borrowBox">
            <div class="intervals">
                <van-field v-model="amount" :label="$t('验资数量')" :placeholder="$t('请输入')" label-width="80px"
                    input-align="right" label-align="left" @input="amountInput">
                </van-field>
                <div class="boxs" @click="allClick">{{ $t('全部') }}</div>
            </div>
            <div class="btnBox">
                {{ $t('可验资金额') }}： <span style="color: #fff;">{{ objData?.product[0]?.money }} USDT</span>
            </div>
            <div class="intervals">
                <van-field v-model="amountT" :label="$t('可借数量')" :placeholder="$t('输入存货数量后评估')" label-width="80px"
                    input-align="right" label-align="left" readonly>
                </van-field>
                <div class="boxs" style="display: flex;align-items: center;justify-content: center;">
                    <van-image height="26" :src="require('@/assets/img/footer/icon6.png')" />
                </div>
            </div>
            <div class="btnBox">
                {{ $t('根据个人资产情况进行，同步借币额度') }}
            </div>
            <div class="textBox"> {{ $t('借币期限') }}</div>
            <div class="theTermBox">
                <div class="theTerm" :class="{ 'theTermS': theTermIndex == index }"
                    v-for="(value, index) in objData.day_list" :key="value" @click="theTermC(index)">
                    {{ value }}{{ $t('天') }}
                </div>
            </div>
            <div class="itemBox">
                <div>
                    {{ $t('日币利息') }}
                    <van-icon name="question" color="#00f0ff" style="padding-left: 6px;" size="18"
                        @click="showPopup = true" />
                </div>
                <div>{{ objData.borrow_rate }} %</div>
            </div>
            <div class="itemBox">
                <div>
                    {{ $t('总币息') }}
                </div>
                <div>{{ totalInterest }} USDT</div>
            </div>
            <div class="itemBox">
                <div>
                    {{ $t('总服务费') }}
                </div>
                <div>{{ objData.borrow_fee }} USDT</div>
            </div>
            <div class="itemBox">
                <div>
                    {{ $t('预估应还') }}
                </div>
                <div>{{ repayment }} USDT</div>
            </div>
            <div style="display: flex;align-items: center;height: 25px;">
                <van-checkbox v-model="checked" shape="square" class="van-checkbox" icon-size="14">
                </van-checkbox>
                <div style="padding-left: 10px;font-size: 14px;color: #999;">{{ $t('我已经阅读并同意') }}</div>
                <div style="padding-left: 10px;font-size: 14px;color: #6592e9;"
                    @click="$router.push(`/mobile/details?type=11`)">
                    {{ $t('借币服务协议') }}</div>
            </div>
            <div class="btnClick" @click="borrowSubmit">{{ $t('立即借币') }}</div>
        </div>


        <van-tabs v-model="active" @change="onChange" background="#000" title-active-color="#00f0ff"
            title-inactive-color="#888" color="#00f0ff">
            <van-tab v-for="item in source" :key="item.id" :title="item.name">
                <div class="scroll">
                    <div v-if="orderList.length > 0">
                        <div v-for="value in orderList" :key="value.id" class="boxS">
                            <div class="boxItem">
                                <div>
                                    <div style="color: #00f0ff;">{{ value.status_text }}</div>
                                    <div style="color: #fff;padding-top: 10px;">{{ value.order_sn }}</div>
                                </div>
                                <div class="boxCk" v-if="value.status == 2 || value.status == 3"
                                    @click="borrowRepay(value.id)">{{ $t('立即还款') }}</div>
                            </div>
                            <div class="boxItem">
                                <div>{{ $t('借款时间') }}</div>
                                <div>{{ value.createtime_text }}</div>
                            </div>
                            <div class="boxItem">
                                <div>{{ $t('验资金额') }}</div>
                                <div>{{ value.money }}USDT</div>
                            </div>
                            <div class="boxItem">
                                <div>{{ $t('还款时间') }}</div>
                                <div>{{ value.repaytime_text }}</div>
                            </div>
                            <div class="boxItem">
                                <div>{{ $t('日币息率') }}</div>
                                <div>{{ value.daily_interest_rate * 100 }}%</div>
                            </div>
                            <div class="boxItem">
                                <div>{{ $t('总服务费') }}</div>
                                <div>{{ value.service_charge }}USDT</div>
                            </div>
                            <div class="boxItem">
                                <div>{{ $t('滞纳金百分比') }}</div>
                                <div>{{ value.late_rate * 100 }}%</div>
                            </div>
                            <div class="boxItem">
                                <div>{{ $t('借币数量') }}</div>
                                <div>{{ value.amount }}USDT</div>
                            </div>
                            <div class="boxItem">
                                <div>{{ $t('借币期限') }}</div>
                                <div>{{ value.period }}</div>
                            </div>
                            <div class="boxItem">
                                <div>{{ $t('剩余时间') }}</div>
                                <div>{{ value.remanenttime }} {{ $t('天') }}</div>
                            </div>
                            <div class="boxItem">
                                <div>{{ $t('当前币息') }}</div>
                                <div>{{ value.interest_amount }} USDT</div>
                            </div>
                            <div class="boxItem">
                                <div>{{ $t('滞纳金') }}</div>
                                <div>{{ value.late_amount }} USDT</div>
                            </div>
                            <div class="boxItem">
                                <div>{{ $t('应还总额') }}</div>
                                <div>{{ value.repay_amount }} USDT</div>
                            </div>
                        </div>
                    </div>
                    <van-empty :description="$t('暂无数据')" v-else />
                </div>
            </van-tab>
        </van-tabs>

        <van-popup v-model="showPopup" position="bottom" closeable close-icon="close" :style="{ height: '90%' }">
            <div class="popupId" v-html="objData?.richtext?.content">
            </div>
        </van-popup>
    </div>
</template>
<script>
import { get, post } from '@/http/request'

export default {
    components: {
    },
    data() {
        return {
            showPopup: false,
            amount: "",
            amountT: '',
            active: 0,
            source: [{
                id: 0,
                name: this.$t('在借订单')
            },
            {
                id: 1,
                name: this.$t('历史订单')
            }],
            users: [],
            theTermIndex: 0,
            checked: false,
            objData: {
                product: []
            },
            totalInterest: 0,
            repayment: 0,
            orderList: []

        };
    },
    mounted() {
        this.borrowGetData()
        this.borrowOrderList()
    },
    beforeUnmount() { },
    methods: {
        onChange(name, title) {
            console.log("切换到", name, title)
            console.log(this.active);
            this.borrowGetData()
            this.borrowOrderList()
        },
        theTermC(index) {
            this.theTermIndex = index
            this.totalInterest = this.amountT * (this.objData.day_list[this.theTermIndex] * this.objData.borrow_rate / 100) + Number(this.objData.borrow_fee) || 0
            this.repayment = Number(this.amountT) ? Number(this.totalInterest) + Number(this.amountT) : 0
        },
        allClick() {
            const val = this.objData?.product?.[0]?.money
            this.amount = Number(String(val).replace(/[^0-9.-]/g, ''))
            this.amountT = this.amount * (this.objData.borrow_limit_rate / 100) || 0
            this.totalInterest = this.amountT * (this.objData.day_list[this.theTermIndex] * this.objData.borrow_rate / 100) + Number(this.objData.borrow_fee) || 0
            this.repayment = Number(this.amountT) ? Number(this.totalInterest) + Number(this.amountT) : 0
        },
        amountInput() {
            this.amountT = this.amount * (this.objData.borrow_limit_rate / 100) || 0
            this.totalInterest = this.amountT * (this.objData.day_list[this.theTermIndex] * this.objData.borrow_rate / 100) + Number(this.objData.borrow_fee) || 0
            this.repayment = Number(this.amountT) ? Number(this.totalInterest) + Number(this.amountT) : 0
        },

        async borrowGetData() {
            const res = await get(this.$apis.borrowGetData)
            if (res.code == 1) {
                this.objData = res.data
                return
            }
        },

        async borrowRepay(id) {
            const res = await get(this.$apis.borrowRepay, { order_id: id })
            if (res.code == 1) {
                this.$toast(res.msg);
                setTimeout(() => {
                    this.borrowOrderList()
                }, 800)
                return
            }
        },


        trade(item) {
            this.$router.push(`/mobile/trade?code=${item.symbol}`)
        },
        async borrowSubmit() {
            console.log(this.checked);

            if (!this.checked) {
                this.$toast(this.$t('请阅读并同意借币服务协议'));
                return
            }
            const res = await post(this.$apis.borrowSubmit, {
                day: this.objData.day_list[this.theTermIndex],
                product_id: this.objData.product[0].id,
                amount: this.amount
            })
            if (res.code == 1) {
                this.amount = 0
                this.amountT = 0
                this.$toast(res.msg);
                setTimeout(() => {
                    // this.borrowGetData()
                    this.borrowOrderList()
                }, 800)
                return
            }
        },
        async borrowOrderList() {
            const res = await get(this.$apis.getBorrowOrderList, {
                limit: 99999,
                type: this.active,
            })
            if (res.code == 1) {
                console.log(res.data);
                this.orderList = res.data.data
                return
            }
        },


    },
};
</script>
<style lang="less" scoped>
.popupId {
    background-color: #12141e;
    height: 90vh;
    padding: 30px 20px;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.id {
    color: #fff;
    padding: 0 15px;
    padding-bottom: 20px;
    padding-top: 50px;
    font-size: 14px;


    .navBar {
        padding: 15px 10px;
        font-size: 18px;
        font-weight: 700;
        border-radius: 4px;
    }

    .topBox {
        background-color: #12141e;
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 5px;
        margin-bottom: 10px;

        .boxIt {
            text-align: center;
            color: #898a8f;

            div:nth-child(2) {
                color: #fff;
                font-size: 24px;
                padding-top: 10px;
            }
        }

    }

    .borrowBox {
        width: 100%;
        height: auto;
        border-radius: 5px;
        border: 1px solid #2c2c3e;
        margin-left: 0;
        background: #12141e;
        padding: 20px 10px;

        .textBox {
            font-size: 18px;
        }

        .theTermBox {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            padding-top: 20px;

            .theTerm {
                border: 1px solid #888;
                width: 30%;
                height: 38px;
                line-height: 38px;
                text-align: center;
                font-size: 14px;
                margin-bottom: 20px;
                border-radius: 99px;
                cursor: pointer;
            }

            .theTermS {
                background-color: #00f0ff;
                color: #000;
                border: 1px solid #00f0ff;
            }

        }

        .itemBox {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 8px;

            div:nth-child(1) {
                color: #888;
                display: flex;
                align-items: center;
            }

            div:nth-child(2) {
                color: #fff;
            }
        }

        .btnClick {
            width: 100%;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            margin-top: 20px;
            border-radius: 99px;
            background: #00f0ff;
            text-align: center;
            border: 0;
            color: #000;
            font-weight: 700;
        }

        .van-checkbox {
            padding: 20px 0;
            font-size: 16px;
        }

        ::v-deep .van-checkbox__label {
            margin-left: 26px !important;
            font-size: 26px;
        }



        .btnBox {
            margin-bottom: 20px;
            padding-left: 2px;
            color: #888;
        }

        .intervals {
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            ::v-deep .van-cell {
                color: #fff;
                height: 40px;
                display: flex;
                align-items: center;
                border-radius: 5px;
            }

            ::v-deep .van-cell::after {
                border-bottom: 0px solid #272737;
            }

            .boxs {
                background-color: #000000;
                height: 40px;
                line-height: 40px;
                width: 80px;
                text-align: center;
                border-radius: 5px;
                margin-left: 10px;
                font-size: 14px;
            }
        }
    }


    ::v-deep .van-search__action:active {
        background-color: transparent !important;
    }

    ::v-deep .van-search__action {
        color: #fff;
        margin-left: 10px;
    }

    ::v-deep .van-search__content {
        background-color: #000;
        border: 1px solid #999 !important;
        color: #323233;
        border-radius: 6px;
        overflow: hidden;
    }

    ::v-deep .van-field__control {
        color: #fff;
    }

    ::v-deep .van-tabs__line {
        width: 100px !important;
    }



    .title {
        display: flex;
        align-items: center;
        padding: 20px 0;
        font-size: 16px;

        div:nth-child(1) {
            padding: 4px;
            background: #00f0ff;
        }

        div:nth-child(2) {
            padding-left: 10px;
        }
    }



    .scroll {
        // overflow-y: auto;
        // height: 55vh;
        // scrollbar-width: none;
        // -ms-overflow-style: none;
        border: 1px solid #31323f;
        border-radius: 10px;
        margin-top: 20px;

        .boxS {
            border-bottom: 1px solid #222630;
            padding: 20px;
            padding-bottom: 0;
            color: #888;

            .boxItem {
                display: flex;
                align-items: center;
                padding-bottom: 15px;
                justify-content: space-between;

                .boxCk {
                    background-color: #404154;
                    color: #fff;
                    padding: 8px 16px;
                    border-radius: 10px;
                    display: inline-block;
                    font-size: 12px;
                }


                div:nth-child(2) {
                    color: #fff;
                }
            }
        }

        .boxS:last-child {
            border-bottom: 0px solid #222630;
        }
    }
}
</style>
